module.exports = __webpack_public_path__ + "img/02.2db396f6.jpg";